<template>
    <div>
        <FilterTable 
          :resource_name="resource_name"
          :title="title"
          :field_definitions="field_definitions"
          :filters="filters"
          :action_buttons="action_buttons"
          :row_actions="row_actions"
          :translate_to_display_data="translate_to_display_data"
          :route_root="route_root"
          :handle_row_action="handle_row_action"
          :full_text_search="true"
          :handle_action_button_click="handle_action_button_click"
          :handle_table_action="handle_table_action"
          :table_actions="table_actions"
          :resource_identifier="resource_identifier"
          :update_flag="filter_table_update_flag"
        />
        <el-dialog
          title="指定審核代理人"
          :visible.sync="dialog_visible"
          width="30%"
          center
        >
          <AssignReviewDeputyPage 
            @done="dialog_visible = false"
          />
        </el-dialog>
        <LoadingBlock
            :active="loading">
        </LoadingBlock>
    </div>
</template>

<script>
// @ is an alias to /src
//import Main from '@/components/backstage/Main.vue'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import AssignReviewDeputyPage from '@/views/backstage/pages/review_management/AssignReviewDeputyPage.vue'
import api from '@/api/index'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'
import articleExportMixin from '@/mixins/articleExportMixin'

export default {
    mixins: [
      breadcrumbMixin,
      articleExportMixin
    ],
    components: {
      LoadingBlock,
      FilterTable,
      AssignReviewDeputyPage
    },
    created () {
      this.permission_check({
        resource_info: { name: this.page_name.PAGE_REVIEW },
        access: { name: this.permission.VIEW },
        reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
      })
    },
    data() {
      return {
        resource_name: 'article',
        resource_identifier: {
          name: 'review_status',
          value: '待審核',
          form: 'json'
        },
        title: '審核資料',
        route_root: 'review-management',
        field_definitions: [
          {
            display: {
              name: '編號',
              type: 'string',
              sortable: 'custom', 
              width: '80px',
            },
            source: {
              type: 'db',
              key: 'system_id',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '類型',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'series_name',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '單件題名',
              type: 'string',
              sortable: 'custom',
              width: '400px',
            },
            source: {
              type: 'db',
              key: 'title',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '全宗名',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'recordgroup_name',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '建立時間',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'in_review_time',
              data_type: 'datetime',
            }
          },
          {
            display: {
              name: '上傳單位',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'org_name',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '上傳者',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'username',
              data_type: 'string',
            }
          },
        ],
        filters: {
          '選擇時間區間': {
            paramName: 'in_review_time',
            value: {
              'start': null,
              'end': null
            },
            options: {
                type: 'time-range',
            }
          },
        },
        action_buttons: {
          add: {
            label: '指定審核代理人',
            action: 'add-deputy',
            enable: () => this.permission_check({
              resource_info: { name: this.permission.RESOURCE_REVIEW },
              access: { name: this.permission.ASSIGN_DEPUTY },
            })
          },
        },
        table_actions: {
          online: {
            label: '批次上線',
            action: 'online'
          },
          offline: {
            label: '取消上線',
            action: 'offline'
          },
          export_selected: {
            label: '匯出勾選項目',
            action: 'export-selected'
          },
          export_filtered: {
            label: '匯出搜尋結果',
            action: 'export-filtered'
          },
        },
        row_actions: {
          get: {
            label: '檢視',
            action: 'get'
          }
        },

        dialog_visible: false,
        dialog_btn_enabled: false,
        dialog_selection: null,

        filter_table_update_flag: 0,
        loading: false
      }
    },
    methods: {
      handle_row_action (action, index, row) {
        console.log('ReviewManagementPage: action:' + action + ', index: ' + index + ', row: ', row)

          switch(action){
            case 'get': 
                let link = this.$router.resolve({ path: `/backstage/${this.route_root}/${row.series_table_name}/view/${row.system_id}` })
                window.open(link .href, '_blank')
                break
            default:
                break
          }
      },
      handle_table_action ({action, selection, data, search_param}) {
        console.log('ReviewManagementPage: action:', action , ', selection: ', selection, ', data: ', data)

        switch(action){
          case 'online':
          case 'offline':
            this.handle_table_action_online(action, selection)
            break
          case 'export-selected':
          case 'export-filtered':
              this.handle_table_export_action(action, selection, search_param)
              break
          default:
            console.warn('[WARN] Unhandled action=', action)
            break
        }
      },
      handle_action_button_click (action) {
        console.log('ReviewManagementPage: action button clicked: ', action)

        switch(action){
          case 'add-deputy': 
              this.dialog_visible = true
            break
          case 'export': 
              break
          default:
              break
        }
      },
      async handle_table_action_online (action, selection) {
        
        if (['online','offline'].indexOf(action) === -1) {
          return
        }

        let ids = selection.map(article => article['system_id'])

        this.loading = true
        let res = await api.review_article( ids, action === 'online')
        this.loading = false

        if (res['success'] !== true) {
          this.$message({
            type: 'error',
            message: `上線/取消上線失敗. ${res['message']}`
          })
        }
        this.notify_message(this.ERROR.LEVEL.SUCCESS, '上線/取消上線成功')
        this.handle_table_update()
      },
      handle_table_update () {
        this.filter_table_update_flag += 1
      }
    }
  };
</script>

<style>
</style>
